import { render } from "./ItemDisplay.vue?vue&type=template&id=3b9b2f23"
import script from "./ItemDisplay.vue?vue&type=script&lang=js"
export * from "./ItemDisplay.vue?vue&type=script&lang=js"

import "./ItemDisplay.vue?vue&type=style&index=0&id=3b9b2f23&lang=css"
script.render = render

export default script